/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getGoal} from '../api'

 export const useQueryGetGoal = createReactQueryHook('getGoal', getGoal)
